import ms from 'ms';

/**
 * LAAC-2038 — Exit-Intent Save Prompt.
 *
 * Durations flagged in the spec as likely to be tuned post-launch; keep as named constants
 * rather than inlining magic numbers (spec Sections 5, 7, 8).
 */

/** Minimum cumulative dwell time on an LDP for the view to be eligible to arm (spec Section 5, AC 1-2). */
export const DWELL_MS = ms('6s');

/** Delay after the destination page is interactive before the prompt renders (spec Section 5/7, AC 4). */
export const PROMPT_DELAY_MS = 800;

/** Silent auto-dismiss timeout, desktop (spec Section 7, AC 18). */
export const AUTO_DISMISS_DESKTOP_MS = ms('12s');

/** Silent auto-dismiss timeout, mobile web (spec Section 7, AC 18). */
export const AUTO_DISMISS_MOBILE_MS = ms('8s');

/** Post-prompt cooldown during which no new prompt may show (spec Section 7, AC 15). */
export const COOLDOWN_MS = ms('5s');

/** Confirmation toast auto-dismiss duration (spec Section 7). */
export const CONFIRM_TOAST_MS = ms('5s');

/** Max prompts shown per session, regardless of lot (spec Section 5, AC 11). */
export const GLOBAL_CAP = 5;

/** sessionStorage key prefix + individual keys (spec Section 8). */
export const SESSION_KEYS = {
    sessionPromptCount: 'la_exitIntentSave_count',
    pending: 'la_exitIntentSave_pending',
    shownLots: 'la_exitIntentSave_shownLots',
    userDismissed: 'la_exitIntentSave_userDismissed',
    userSaved: 'la_exitIntentSave_userSaved',
} as const;
